import axios from 'axios';
import setAuthorizationToken from './setAuthorizationToken';
import setDeviceId from './setDeviceId';
import notification from '../components/Base/Notification';

export default {
  init: store => {
    axios.interceptors.response.use(
      response => {
        if (sessionStorage.getItem('BTCADVANCE')) {
          setAuthorizationToken(sessionStorage.BTCADVANCE);
          setDeviceId(localStorage.BTC_device_id);
        } else if (localStorage.getItem('BTCADVANCE')) {
          setAuthorizationToken(localStorage.BTCADVANCE);
          setDeviceId(localStorage.BTCADVANCE_device_id);
        }
        return response;
      },
      e => {
        if (e.response?.status === 401) {

          // store.dispatch(logout());
          notification({
            type: 'error',
            message: 'Session was ended!',
          });
          setAuthorizationToken();
          setDeviceId();
          localStorage.removeItem('BTCADVANCE');
          sessionStorage.removeItem('BTCADVANCE');
          window.location.replace('/');
          return false;
        }
        return Promise.reject(e);
      },
    );
  },
};
